import {Tooltip, useTheme} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

export const MobileTooltip = (props) => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    return <Tooltip {...props} title={!isDesktop && !props.override ? "" : props.title} disableTouchListener>
        {props.children}
    </Tooltip>
}